import { useState } from "react";
import FinancialModelAWS from "../../stacks/financialModel/FinancialModelAWS";

export const useDeleteScenario = (id, cb) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState({});

  function refetch(_id) {
    async function call() {
      setLoading(true);
      try {
        const financialModelApi = FinancialModelAWS.getInstance();
        const fin = await financialModelApi.removeForecast(_id || id);
        setData(fin);
        setError("");
        setLoading(false);
        cb && cb();
      } catch (err) {
        console.log(`ERROR adding forecasts ${err.message}`);
        setError(err.message);
        setLoading(false);
      }
    }
    call();
  }

  return [{ loading, error, data }, refetch];
};

// async function remove() {
//   try {
//     setResult(undefined);
//     setLoading(true);
//     setErrorMsg("");
//     const financialModelApi = FinancialModel.getInstance();
//     const [forecastId, value] = Object.entries(forecasts)[0];
//     const fin = await financialModelApi.removeForcast(forecastId);
//     setResult(fin);
//     setLoading(false);
//     retrieve();
//   } catch (err) {
//     console.log(`ERROR adding forecasts ${err.message}`);
//     setErrorMsg(err.message);
//     setLoading(false);
//   }
// }
